import moment from 'moment'
export const familyGroupTitle = (rowdata: any): string => {

  let title = "";

  if (rowdata.OldFamilyGroup === undefined || rowdata.OldFamilyGroup === null || rowdata.OldFamilyGroup === "") {
    title = "";
  }
  else {
    title = "Family group changed from : " + rowdata.OldFamilyGroup;
  }



  return title;

}
export const lastUpdatedTooltip = (rowdata: any): string => {

  if (rowdata.FamilyGroupUpdatedDate !== undefined || rowdata.FamilyGroupUpdatedDate !== null || rowdata.FamilyGroupUpdatedDate !== "") {
    const currentDate = moment();
    var updatedDate = moment(rowdata.FamilyGroupUpdatedDate, "YYYY-MM-DD")

    if (currentDate.diff(updatedDate, "days") < 7) {
      return "true";
    }
    else {
      return "false";
    }
  }
  else {
    return "false";
  }





}